import { useRouter } from 'next/router';
import { useAtomValue } from 'jotai';

import { useAuth } from '@restworld/feature-authentication';

import { useWorkerApplicationCxt } from '../../worker-application-wizard.context';
import { entryPointSignupConsentAtom } from '../../../worker-entry-point/worker-entry-point.atoms';

/**
 * Whether the first step shows the signup boxes (RW-422). Always on `/candidati`; on a job page
 * only when the entry point's answer is missing (a refresh or a direct link to the wizard), so no
 * account is ever created without the boxes. Never once the person already has a worker account.
 */
export const useWizardShowsSignupBoxes = (): boolean => {
  const router = useRouter();
  const { user } = useAuth();
  const { workerId } = useWorkerApplicationCxt();
  const entryPointSignupConsent = useAtomValue(entryPointSignupConsentAtom);
  if (workerId && user?.type !== 'lead') return false;
  return !router?.query?.id || !entryPointSignupConsent;
};
